import logo from './landing-image.png';
import bookCover from './book-cover.png';
import authorBioIamge from './author-bio.jpg';
import fogImage1 from './fog1.png';
import fogImage2 from './fog2.png';
import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';

function App() {
  return (
    <div className="App">
      <nav id="navbar-main" className="navbar navbar-expand-md navbar-dark fixed-top">
        <div className="container-fluid">
          <a id="author-title" className="navbar-brand d-md-none" href="#">
            Ashlen Jordan
          </a>
          <button id="hamburger" className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
            <i className="bi bi-list"></i>
          </button>
          <div className="collapse navbar-collapse" id="navbarNav">
            <ul className="navbar-nav mx-auto navbar-nav-scroll">
              <li className="nav-item">
                <a className="nav-link" aria-current="page" href="#">Home</a>
              </li>
              <li className="nav-item">
                <a className="nav-link" href="#books">Books</a>
              </li>
              <a id="author-title" className="navbar-brand d-none d-md-block" href="#">
                Ashlen Jordan
              </a>
              <li className="nav-item">
                <a className="nav-link" href="#about">About</a>
              </li>
              <li className="nav-item">
                <a className="nav-link" href="#">Contact</a>
              </li>
            </ul>
          </div>
        </div>
      </nav>
      <nav id="navbar-socials" className="navbar navbar-expand-md navbar-dark fixed-top">
        <div className="container-fluid">
          <ul className="navbar-nav ms-auto navbar-nav-scroll">
            <li className="nav-item">
              <a className="nav-link social" href="https://www.tiktok.com/@ashlenjordan_author"><i className="bi bi-tiktok"></i></a>
            </li>
            <li className="nav-item">
              <a className="nav-link social" href="https://www.facebook.com/ashlen.jordan.5"><i className="bi bi-facebook"></i></a>
            </li>
            <li className="nav-item">
              <a className="nav-link social" href="https://www.instagram.com/ashlenjordan_author"><i className="bi bi-instagram"></i></a>
            </li>
          </ul>
        </div>
      </nav>
      <div id="landing-image" className="container-fluid"
        style={{backgroundImage: "url(" + logo + ")"}}>
      </div>
      <div className="container">
        <div className="row">
          <div className="col-6" id="landing-blurb">
            <p id="landing-sub-header">She finally felt...</p>
            <p id="landing-header">Alive</p>
          </div>
          <div className="col-5"> </div>
        </div>
      </div>
      <div className="container" id="books">
        <div className="row justify-content-center">
          <div className="col-5">
            <img id="book-cover" src={bookCover} alt="Book Cover" />
          </div>
          <div id="book-blurb-div" className="col-7">
            <p id="book-title">Hearts and Hellfire</p>
            <p className="book-blurb">
              Elsie is one of the last surviving members of the Pax Dynasty – a family of dragons who, for centuries, have protected Terra Draconum’s most vulnerable inhabitants from the dark forces that threaten the realm and all its creatures. 
            </p>
            <p className="book-blurb">
              But one hundred and fifty years ago, one of those dark forces captured and enslaved Elsie and locked her away in a dungeon, so they could break her will, turn her into a ruthless warrior, and force her to exact revenge on their enemies. Her company is that the mysterious, unembodied voice that speaks to her unbidden, supporting, taunting, and flirting with her. 
            </p>
            <p className="book-blurb">
              Just when she reaches the depths of her despair and becomes resigned to her fate, Elsie’s first true love, Karma, rescues her and whisks her away to his family’s kingdom, Rexarius.  His people become her people, and over time, Elsie begins to heal and grows comfortable in her new realm, her new life, and her new role as co-ruler of Rexarius. Before long, Karma’s land and its people feel like home to Elsie. 
            </p>
            <p className="book-blurb">
              Just as life starts to have meaning for Elsie again, and she feels safe with her newfound family, Karma’s dark intentions are revealed, and amidst an unfolding war between rival kingdoms, Elsie is forced to accept that she never really knew him and that the enigmatic voice that’s been guiding her has been telling her the truth from the beginning.
            </p>
            <p className="book-blurb">
              Now, Elsie must confront the man she once trusted with her life and her heart to learn the truth behind the centuries of lies and deceit that led to her original family’s slaughter.  Fighting and defeating her first true love is the only way she will be able to reclaim her birthright, realize her destiny, and save her newfound family from a fate far worse than death – eternal enslavement by the dragons fighting to stake their claim as gods of Concordia. 
            </p>
          </div>
        </div>
      </div>
      <div id="fog-div">
        <div className="container-fluid " id="about">
          <div className="row justify-content-center">
            <div id="about-text" className="col-6">
              <p id="about-title">
                About the Author
              </p>
              <p className="author-bio">
                Ashlen Jordan is an author who grew up surrounded by books and teachers, but her love for reading was often misunderstood. While her peers teased her for reading well above grade level, books became her escape from the world. Though Ashlen first considered writing in high school, she found herself disillusioned with college and ultimately dropped out. 
              </p>
              <p className="author-bio">
                Today, she writes about tragic love and fantastical worlds, drawing from her own experiences. Living through her share of misguided relationships, seeking solace in her imagination. It was through this escape that her passion for fantasy and maladaptive daydreaming collided. Thus, allowing her to craft stories that transport readers to worlds full of emotion, chaos, and unforgettable twists.
              </p>
              <p className="author-bio">
                As the self-proclaimed chaotic friend in her circle, Ashlen balances her love for adventure and creativity with the ability to listen, offering a grounded perspective when others need it. A proud anime enthusiast, BookTok aficionado, passionate horse owner, and lover of all things with fur and scales. Ashlen’s true joy outside all those things in life is the electric energy of rave culture and embracing the PLUR spirit.
              </p>
              <p id="author-slogan">Turning tragedies into fantastical tales</p>
              <p id="author-bio-signature">- Ashlen Jordan</p>
            </div>
            <div id="author-bio-frame" className="col-4">
              <div style={{backgroundImage: "url("+authorBioIamge+")"}} id="author-bio-image"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default App;
